module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/HighGrowthCulture_NationalInstruments_bg.5ce8524e.jpg";